// extracted by mini-css-extract-plugin
export default {"title":"Title_title__BY5Ll","h1":"Title_h1__xpkxH","h2":"Title_h2__iG0Oi"};